/* global require */
import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ColorPicker from './color-picker';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor() {
        super();
        const config = require('../../../config.json');
        let colors = [];

        Object.keys(config.colors).map(name => {
            colors.push({
                hex: config.colors[name].replace(/#/, ''),
                name: name,
            });
        });

        this.state = { colors: _.indexBy(colors, 'hex') };
    }

    render() {
        return (
            <section id='colors'>
                <fieldset>
                    <legend>
                        <h2><a href='#colors'>#</a> Colors</h2>
                    </legend>
                    <row>
                        <column>
                            <p>
                                Below are the {Object.keys(this.state.colors).length} colors in use on our site. To
                                use a color, hover over any swatch to get it's name. You can also click any swatch to
                                have the name copied to your clipboard. Use the name in either of the classes below to
                                style text or background.
                            </p>
                            {this.renderColors()}
                        </column>
                    </row>
                </fieldset>
                <fieldset id='CSS'>
                    <legend>
                        <h2><a href='#colors'>#</a> Colors</h2>
                    </legend>
                    <row>
                        <column>
                            <p>
                                Use the classes below (in conjunction with one of the names from above) to set either
                                the text color or background of an element.
                            </p>
                            <table className='is-bordered'>
                                <thead>
                                    <tr>
                                        <th>Class</th>
                                        <th>Example</th>
                                        <th>Result</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><code className='prettyprint'>has-text-[color name]</code></td>
                                        <td>
                                            <code className='prettyprint lang-html'>
                                                &lt;p className="has-text-shakespeare"&gt;example text&lt;/p&gt;
                                            </code>
                                        </td>
                                        <td><p className='has-text-shakespeare'>example text</p></td>
                                    </tr>
                                    <tr>
                                        <td><code className='prettyprint'>is-background-[color name]</code></td>
                                        <td>
                                            <code className='prettyprint lang-html'>
                                                &lt;p className="is-background-aqua-island"&gt;example text&lt;/p&gt;
                                            </code>
                                        </td>
                                        <td><p className='is-background-aqua-island'>example text</p></td>
                                    </tr>
                                </tbody>
                            </table>
                        </column>
                    </row>
                </fieldset>
                <fieldset id='SCSS'>
                    <legend>
                        <h2><a href='#SCSS'>#</a> SCSS</h2>
                    </legend>
                    <row>
                        <column className='is-12'>
                            <dl>
                                <dt>To find the name of a color:</dt>
                                <dd>
                                    <ColorPicker />
                                </dd>
                                <dd>
                                    Enter the name and HEX code that is returned, into the&nbsp;
                                    <code className='prettyprint'>colors:</code> section of&nbsp;
                                    <code className='prettyprint'>
                                        <span className='nocode'>/web_modules/config.json</span>
                                    </code> <b>ALPHABETICALLY</b>.
                                </dd>
                                <dd>The color name should be lowercase, with spaces replaced with hyphens.</dd>
                                <dd>
                                    Example:&nbsp;
                                    <code className='prettyprint lang-json'>"havelock-blue": "#3d95d6",</code>
                                </dd>
                            </dl>
                            <br />
                            <p>There is a SCSS function that is used to render the correct colors listed above.</p>
                            <table className='is-bordered'>
                                <thead>
                                    <tr>
                                        <th>Function</th>
                                        <th>Examples</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <code className='prettyprint'>
                                                <span className='nocode'>
                                                    color([color name], [lighten/darken], [opacity])
                                                </span>
                                            </code>
                                            <br />
                                            Returns the HEX value of the named color from the colors json
                                        </td>
                                        <td>
                                            <code className='prettyprint lang-css'>
                                                color: color(shakespeare);<br />
                                                background-color: color(havelock-blue);<br />
                                                border: 1px solid color(eminence);
                                            </code>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </column>
                    </row>
                </fieldset>
            </section>
        );
    }

    renderColors = () => {
        return Object.keys(this.state.colors).map(key => {
            const color = this.state.colors[key];
            return (
                <div
                    className={`swatch is-background-${color.name}`}
                    title={color.name}
                    onClick={() => this.copyName(color.name)}
                />
            );
        });
    }

    copyName = (name) => {
        const el = document.createElement('textarea');
        el.value = name;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
}

export default connect()(Component);
